import * as KatalMetrics from "@amzn/katal-metrics";
import KatalMetricsDriver from "@amzn/katal-metrics/lib/driver/KatalMetricsDriver";
import { MetricsState } from "./metricsSlice";
import errorHandler from "./errorHandler";

/**
 * Factory that creates a KatalMetrics publisher.
 *
 * @export
 * @param {KatalMetricsDriver} metricsDriver
 * @param {MetricsState} state
 * @returns
 */
export default function(
  metricsDriver: KatalMetricsDriver,
  state: MetricsState
) {
  return new KatalMetrics.Publisher(
    metricsDriver,
    errorHandler,
    new KatalMetrics.Context.Builder()
      .withSite(state.config.siteName)
      .withServiceName(state.config.serviceName)
      .withRelatedMetrics(
        new KatalMetrics.Metric.String("sessionId", state.config.sessionId)
      )
      .build()
  );
}
